import type { MagnitudePageProps } from "types/magnitude";
import dynamic from "next/dynamic";
import type { MagnitudeTemplateProps } from "../MagnitudeTemplate";
import type { MagnitudeTopicTemplateProps } from "../MagnitudeTopicTemplate";

const MagnitudeTemplate = dynamic<MagnitudeTemplateProps>(() =>
  import("modules/magnitude/templates/MagnitudeTemplate").then((m) => m.MagnitudeTemplate)
);
const MagnitudeTopicTemplate = dynamic<MagnitudeTopicTemplateProps>(() =>
  import("modules/magnitude/templates/MagnitudeTopicTemplate").then((m) => m.MagnitudeTopicTemplate)
);

export const MagnitudePage = (props: MagnitudePageProps) => {
  const { templateComponent } = props;
  switch (templateComponent) {
    case "magnitude": {
      return <MagnitudeTemplate {...props} />;
    }
    case "magnitudeTopic": {
      return <MagnitudeTopicTemplate {...props} />;
    }

    default:
      throw new Error(`Unexpected Template: ${templateComponent}`);
  }
};
